import './Spinner.scss';

const Spinner = () => {
  return <div className="Spinner" />;
};

export default Spinner;
